import { Toaster as Sonner } from "sonner";

export function Toaster(props) {
  return (
    <Sonner
      theme="system"
      position="top-right"
      richColors
      closeButton
      visibleToasts={3}
      toastOptions={{
        classNames: {
          toast: "rounded-lg shadow-lg",
        },
      }}
      {...props}
    />
  );
}
